export default "__VITE_ASSET__CpO$t4gg__"